import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetLocationDetails = () =>
  useMutation({
    mutationFn: (servicePointId) =>
      client(`resources/sites/info/${servicePointId}`, { hideError: true }),
  });
